<template>
    <b-overlay :show="showoverlay" rounded="sm" class='demolistwrap'>
        <div class="card mt-0 border-0 bg-wash no-shadow demolistwrap2 px-2">

            <div class="card-header px-0 bg-transparent border-0">
                <div class="row no-margin" :class="[{ 'company-directory-search-row': is_company_directory == 'yes' }]">
                    <div class="col-sm-6 pl-0 "
                        :class="[is_company_directory == 'yes' ? 'company-directory-search' : 'd-flex']">
                        <b-button v-if="is_company_directory == 'yes'" id="filter_button"
                            class="employee-filter-btn mb-1 custom-secodary-btn" v-b-toggle.sidebar_right> <b-icon
                                class="ml-3" icon="funnel-fill"></b-icon>Filter</b-button>
                        <div class="align-self-center custom-search pr-0 mt-2" style="max-width: 480px;">
                            <b-input-group>
                                <b-input-group-prepend is-text>
                                    <b-icon icon="search"></b-icon>
                                </b-input-group-prepend>
                                <b-form-input type="search" placeholder="Search" v-model="search"
                                    @input="resetPagination()"></b-form-input>
                            </b-input-group>
                        </div>
                        <!-- Mustafijur: 11-05-2026-->
                        <div class="d-inline-block trz_fields trz-custom-dropdown mb-1 trz_people_btn mt-3 ml-2"
                            :class="email_class">
                            <div class="pl-0 company-employee-count" style="height: 31px; position: unset;">
                                <span
                                    class="text-center px-2 border border-right-0 d-inline-block h-100 employee-count-icon">
                                    <b-icon class="" icon="people-fill"></b-icon>
                                </span>
                                <span class="text-center px-2 border d-inline-block h-100 employee-count-number"
                                    style="min-width: 51px;">{{ people }}</span>
                            </div>
                        </div>
                        <!-- Mustafijur: 11-05-2026-->

                        <div class="d-block directory-switch-btns align-top mt-4" v-if="is_company_directory == 'yes'">
                            <div class="d-inline-block">
                                <b-button class="view-mode-btn custom-secodary-btn switch-view-btn"
                                    :class="[{ 'active': viewmode }]" @click="viewmode = true"><b-icon class="list-icon"
                                        icon="list"></b-icon></b-button>
                                <b-button class="view-mode-btn custom-secodary-btn switch-view-btn"
                                    @click="viewmode = false" :class="[{ 'active': !viewmode }]"><b-icon class="grid"
                                        icon="grid"></b-icon></b-button>
                                <span class="view-mode-status d-block"><template v-if="viewmode">List
                                        View</template><template v-else>Grid View</template></span>
                            </div>
                        </div>
                    </div>
                    <div class="col-sm-6 pr-0 trz_ppl_wrapper text-left text-md-right">
                        <div class="col-12 text-right pr-0 trz_ppl_wrapper_2 custom-mobile-stack-btn">
                            <!-- start: added slot for using bulk action button by afrin -->
                            <slot name="bulk-action"></slot>
                            <!-- end: added slot for using bulk action button by afrin -->

                            <!-- Mustafijur rearranged the options. Filter button to top on 12-04-2026 -->
                            <!-- <b-button  id="filter_button" class="employee-filter-btn mb-1 custom-secodary-btn" v-b-toggle.sidebar_right>Filter<b-icon class="ml-3" icon="funnel-fill" ></b-icon></b-button> -->
                            <!-- Mustafijur Commented: on 09-04-2026 -->
                            <b-button v-if="is_company_directory != 'yes'" id="filter_button"
                                class="employee-filter-btn mb-1 custom-secodary-btn align-top mr-1"
                                v-b-toggle.sidebar_right><b-icon class="mr-2"
                                    icon="funnel-fill"></b-icon>Filter</b-button>
                            <!-- Mustafijur Added: on 09-04-2026 -->


                            <template>
                                <!-- hide_fields is added by Afrin -->
                                <div class="d-inline-block trz_fields trz-custom-dropdown mb-1" v-if="viewmode && hide_fields !== 'yes'">
                                    <b-dropdown id="dropdown-fields" text="Select Additional Fields" ref="dropdown"
                                        class="mb-1">
                                        <!-- Mustafijur Changed: Fields to Select Additional Fields and removed class custom-secodary-btn on 09-04-2026 -->
                                        <b-dropdown-form>
                                            <b-form-group @submit.stop.prevent>
                                                <div class="form-group">
                                                    <b-form-checkbox-group switches stacked>
                                                        <b-form-checkbox v-for="column_option in column_options"
                                                            v-model="column_selected" :value="column_option.value"
                                                            :key="column_option.value" switch><template
                                                                v-if="column_option.value == 'jobposition'">Job
                                                                Position</template><template
                                                                v-else-if="column_option.value == 'branch'">Work
                                                                Location</template><template
                                                                v-else-if="column_option.value == 'nid'">NID</template><template
                                                                v-else-if="column_option.value == 'etin'">e-TIN</template><template
                                                                v-else>{{ column_option.text
                                                                }}</template></b-form-checkbox>
                                                    </b-form-checkbox-group>
                                                </div>
                                                <button type="button" @click="setcolumn()"
                                                    class="btn btn-primary d-none">Save</button>
                                            </b-form-group>
                                        </b-dropdown-form>

                                    </b-dropdown>
                                </div>
                            </template>


                            <b-button v-if="switch_view == 1"
                                class="view-mode-btn employee-filter-btn mb-1 custom-secodary-btn switch-view-btn d-none"
                                @click="viewmode = !viewmode">Switch View<b-icon v-if="viewmode" class="ml-3 list-icon"
                                    icon="list-ul"></b-icon><b-icon v-else class="ml-3 grid-icon"
                                    icon="grid3x3-gap-fill"></b-icon></b-button>
                            <!-- Mustafijur Added: class d-none on 12-04-2026 -->
                            <!-- <div class="d-inline-block trz_fields trz-custom-dropdown mb-1 position-absolute trz_people_btn" :class="email_class">
                                <div class="pl-0 company-employee-count" style="height: 31px; position: unset;"><span class="text-center px-2 border border-right-0 d-inline-block h-100 employee-count-icon"><b-icon class="" icon="people-fill"></b-icon></span><span class="text-center px-2 border d-inline-block h-100 employee-count-number" style="min-width: 51px;">{{people}}</span></div>
                            </div> --> <!-- Mustafijur Commented: on 09-04-2026 -->

                            <!-- View Mode Toggle (List / Grid) - Added by Mustafijur on 12-04-2026 -->
                            <div class="d-inline-block directory-switch-btns align-top" v-if="switch_view == 1">
                                <b-button class="view-mode-btn custom-secodary-btn switch-view-btn"
                                    :class="[{ 'active': viewmode }]" @click="viewmode = true"><b-icon class="list-icon"
                                        icon="list"></b-icon></b-button>
                                <b-button class="view-mode-btn custom-secodary-btn switch-view-btn"
                                    @click="viewmode = false" :class="[{ 'active': !viewmode }]"><b-icon class="grid"
                                        icon="grid"></b-icon></b-button>
                                <span class="view-mode-status d-block"><template v-if="viewmode">List
                                        View</template><template v-else>Grid View</template></span>
                            </div>
                            <!-- End View Mode Toggle -->
                        </div>
                    </div>
                </div>
            </div>

            <div class="card-body px-0 container">
                <!--<div class="wrapper1" v-if="viewmode">
                    <div class="div1"></div>
                </div>-->
                <!-- list view starts here -->

                <!--<div class="wrapper2 mb-4" v-if="viewmode"> -->
                <!--<div class="div2">-->

                <div class="employee-table-wrapper"
                    :class="[{ 'no-overflow': paginatedData.length < 8 && is_pf != 1 }, tableStickyHeight]"
                    v-if="viewmode">
                    <!-- alpha fix- added class dataTable  -->
                    <table
                        class="employee-list-table table-overflow table-sticky ess-custom-table document-table tax-documents table-list fund_list_table dataTable"
                        v-if="viewmode">

                        <thead>
                            <!-- alpha fix- added class align-middle  -->
                            <tr class="table-head align-middle">
                                <td class="checkbox-col" v-if="checkbox == 1">
                                    <input v-if="checkbox == 1" type="checkbox" v-model="selectAll" class="">
                                    <label></label>
                                </td>

                                <td v-for="f in default_column">
                                    <template v-for="k in default_options">
                                        <template v-if="f == k.value && f != 'name'">
                                            <!-- alpha fix- added class mb-0  -->
                                            <label class="custom-label mb-0"
                                                :class="sortKey === k.value ? (sortOrders[k.value] > 0 ? 'sorting_asc' : 'sorting_desc') : 'sorting'"
                                                @click="sortBy(k.value)">
                                                <span><template v-if="k.text == 'Jobposition'">Job
                                                        Position</template><template v-else-if="k.text == 'Branch'">Work
                                                        Location</template><template
                                                        v-else-if="k.text == 'Phone'">Mobile Number</template><template
                                                        v-else>{{ k.text }}</template></span>
                                            </label>
                                        </template>
                                        <template v-if="f == k.value && f == 'name'">
                                            <!-- <input v-if ="checkbox==1" type="checkbox" v-model="selectAll" class=""> -->
                                            <!-- alpha fix- removed class pl-5 added px-5 -->
                                            <!-- alpha fix- added class mb-0  -->
                                            <label class="custom-label px-5 mb-0"
                                                :class="sortKey === k.value ? (sortOrders[k.value] > 0 ? 'sorting_asc' : 'sorting_desc') : 'sorting'"
                                                @click="sortBy(k.value)">
                                                <span v-if="is_company_directory == 'yes'">Employee Name</span>
                                                <span v-else>{{ k.text }}</span>
                                            </label>
                                        </template>
                                    </template>
                                </td>
                                <template v-if="is_payruns == 'yes'">
                                    <!-- added by afrin -->
                                    <td class="text-left" v-for="f in column_selected" v-if="!appended_values.includes(f)">
                                        <template v-for="k in column_options">
                                            <template v-if="f == k.value">
                                                <!-- alpha fix- added class mb-0  -->
                                                <label class="custom-label mb-0"
                                                    :class="sortKey === k.value ? (sortOrders[k.value] > 0 ? 'sorting_asc' : 'sorting_desc') : 'sorting'"
                                                    @click="sortBy(k.value)">

                                                    <!-- alpha fix- commented this  -->
                                                    <!-- <span><template
                                                            v-if="k.text == 'Jobposition'">Job</template><template
                        v-else-if="k.text == 'Branch'">Work
                                                            Location</template><template
                        v-else-if="k.text == 'Etin'">e-TIN</template><template v-else>{{ k.text }}</template></span> -->

                                                    <!-- alpha fix added this  -->
                                                    <span><template v-if="k.text == 'Jobposition'">Job
                                                            Position</template><template
                                                            v-else-if="k.text == 'Branch'">Work
                                                            Location</template><template
                                                            v-else-if="k.value == 'nid'">NID</template><template
                                                            v-else-if="k.value == 'etin'">e-TIN</template><template
                                                            v-else>{{ k.text
                                                            }}</template></span>
                                                </label>
                                            </template>
                                        </template>
                                    </td>
                                    <!-- added by afrin -->
                                    <td class="text-center" v-for="f in appended_column" v-if="column_selected.includes(f.value)">
                                        <template v-for="k in appended_options">
                                            <template v-if="f.value == k.value">
                                                <!-- alpha fix- added class mb-0  -->
                                                <label class="custom-label mb-0"
                                                    :class="sortKey === k.value ? (sortOrders[k.value] > 0 ? 'sorting_asc' : 'sorting_desc') : 'sorting'"
                                                    @click="sortBy(k.value)">
                                                    <span><template v-if="k.text == 'Jobposition'">Job
                                                            Position</template><template
                                                            v-else-if="k.text == 'Branch'">Work
                                                            Location</template><template v-else>{{ k.text
                                                            }}</template></span>
                                                </label>
                                            </template>
                                        </template>
                                    </td>
                                </template>
                                <template v-else>
                                    <!-- added by afrin -->
                                    <td class="text-center" v-for="f in appended_column" v-if="column_selected.includes(f.value)">
                                        <template v-for="k in appended_options">
                                            <template v-if="f.value == k.value">
                                                <!-- alpha fix- added class mb-0  -->
                                                <label class="custom-label mb-0"
                                                    :class="sortKey === k.value ? (sortOrders[k.value] > 0 ? 'sorting_asc' : 'sorting_desc') : 'sorting'"
                                                    @click="sortBy(k.value)">
                                                    <span><template v-if="k.text == 'Jobposition'">Job
                                                            Position</template><template
                                                            v-else-if="k.text == 'Branch'">Work
                                                            Location</template><template v-else>{{ k.text
                                                            }}</template></span>
                                                </label>
                                            </template>
                                        </template>
                                    </td>
                                    <!-- added by afrin -->
                                    <td class="text-left" v-for="f in column_selected" v-if="!appended_values.includes(f)">
                                        <template v-for="k in column_options">
                                            <template v-if="f == k.value">
                                                <!-- alpha fix- added class mb-0  -->
                                                <label class="custom-label mb-0"
                                                    :class="sortKey === k.value ? (sortOrders[k.value] > 0 ? 'sorting_asc' : 'sorting_desc') : 'sorting'"
                                                    @click="sortBy(k.value)">
                                                    <!-- alpha fix- commented this  -->
                                                    <!-- <span><template v-if="k.text == 'Jobposition'">Job
                                                            Position</template><template
                            v-else-if="k.text == 'Branch'">Work
                                                            Location</template><template v-else>{{ k.text
                                                            }}</template></span> -->

                                                    <!-- alpha fix- added this  -->

                                                    <span><template v-if="k.text == 'Jobposition'">Job
                                                            Position</template><template
                                                            v-else-if="k.text == 'Branch'">Work
                                                            Location</template><template
                                                            v-else-if="k.value == 'nid'">NID</template><template
                                                            v-else-if="k.value == 'etin'">e-TIN</template><template
                                                            v-else>{{ k.text
                                                            }}</template></span>
                                                </label>
                                            </template>
                                        </template>
                                    </td>
                                </template>
                                <td v-if="is_action == 1" class="action_thead">Action</td>

                            </tr>
                        </thead>
                        <tbody>
                            <tr class="hover-bg table-row" v-for="employee in paginatedData"
                                :key="employee[primary_key]">
                                <template v-if="status_flag">
                                    <template v-if="employee.status == 'Active'">
                                        <template v-if="checkbox == 1">
                                            <td class="checkbox-col">
                                                <input v-if="employee.pay_slip_name && employee.pay_slip_name != ''"
                                                    type="checkbox" class="justify-content-center " v-model="selected"
                                                    :value="employee[primary_key]" number>
                                                <input v-else type="checkbox" class="justify-content-center"
                                                    v-model="selected" :value="employee.employee_id" number>
                                            </td>
                                        </template>
                                        <td class="cursor-pointer trz_relative" v-for="f in default_column">
                                            <template v-if="f == 'phone'"><span class="cursor-pointer"
                                                    @click="editEmployee(employee[primary_key])">{{
                                                        formatPhoneNumber(employee.phone) }}</span></template>
                                            <template v-else-if="f == 'name'">
                                                <template v-if="edit_icon == 'yes'">
                                                    <b-icon
                                                        v-if="employee.draft_flg == 1 || employee.draft_mph == 1 || employee.draft_mpfh == 1 || employee.draft_contract == 1"
                                                        icon="arrow-right-circle" variant="info" animation="fade"
                                                        class="mr-1 trz_employee_draft_edit" v-b-tooltip.hover
                                                        title="Has Draft Data"></b-icon>
                                                    <b-icon v-else icon="blank"
                                                        class="mr-1 trz_employee_draft_edit"></b-icon>
                                                </template>
                                                <!-- <template v-if="checkbox==1" ><input v-if="employee.pay_slip_name && employee.pay_slip_name !=''" type="checkbox" class="justify-content-center " v-model="selected" :value="employee[primary_key]" number><input v-else type="checkbox" class="justify-content-center" v-model="selected" :value="employee.employee_id" number></template> -->
                                                <label class="mb-0 custom-label">
                                                    <template v-if="employee.pic != ''">
                                                        <img v-if="employee.pic == 'no-image.jpg'"
                                                            v-bind:src="$api_url + '/avatar/' + employee.pic"
                                                            class="img-fluid img-thumbnail employee-avatar mx-2" />
                                                        <img v-else
                                                            v-bind:src="$api_url + '/avatar/' + employee.company_id + '/' + employee.pic"
                                                            class="img-fluid img-thumbnail employee-avatar mx-2" />
                                                    </template>
                                                    <template v-else>
                                                        <img v-bind:src="$api_url + '/avatar/demo.jpg'"
                                                            class="img-fluid img-thumbnail employee-avatar mx-2" />
                                                    </template>
                                                    <template
                                                        v-if="employee.pay_slip_name && employee.pay_slip_name != ''">
                                                        <span style="color: rgb(29, 104, 167);" class="cursor-pointer"
                                                            @click="editEmployee(employee[primary_key])">{{
                                                                employee.name }}
                                                            <template v-if="employee.is_manual == 1"><span>( Manual
                                                                    payslip
                                                                    )</span></template></span>
                                                    </template>
                                                    <template v-else>
                                                        <!-- start: added status icon by afrin -->
                                                        <template><span class="cursor-pointer"
                                                                @click="editEmployee(employee[primary_key])">
                                                                <template v-if="f.value == 'status_label'">
                                                                    <template v-if="employee.status == 1"><b-icon
                                                                            icon="check-circle-fill" variant="success"
                                                                            class="mr-2"></b-icon></template>
                                                                    <template v-else><b-icon icon="dash-circle-fill"
                                                                            variant="warning" class="mr-2"></b-icon></template>
                                                                </template>
                                                                {{ employee[f.value] }}</span></template>
                                                        <!-- end: added status icon by afrin -->
                                                    </template>
                                                </label>
                                            </template>
                                            <template v-else>{{ employee[f] }}</template>
                                        </td>
                                        <template v-if="is_payruns == 'yes'">
                                            <!-- added by afrin -->
                                            <td class="cursor-pointer text-left" v-for="f in column_selected" v-if="!appended_values.includes(f)">
                                                <template v-if="f != 'name'"><span class="cursor-pointer"
                                                        @click="editEmployee(employee[primary_key])">{{ employee[f]
                                                        }}</span></template>
                                            </td>
                                            <!-- added by afrin -->
                                            <td class="cursor-pointer text-left" v-for="f in appended_column" v-if="column_selected.includes(f.value)">
                                                <template v-if="employee.pay_slip_name && employee.pay_slip_name != ''">
                                                    <span v-if="f.value == 'reviewed'"
                                                        class="text-center d-block"><template
                                                            v-if="employee[f.value] == 1"><b-icon
                                                                icon="check-circle-fill" class="ml-2"
                                                                variant="success"></b-icon></template><template
                                                            v-else></template></span>
                                                    <span v-else class="text-right d-block">{{ employee[f.value]
                                                        }}</span>
                                                </template>
                                                <template v-else>
                                                    <!-- start: added status icon by afrin -->
                                                    <template><span class="cursor-pointer"
                                                            @click="editEmployee(employee[primary_key])">
                                                            <template v-if="f.value == 'status_label'">
                                                                <template v-if="employee.status == 1"><b-icon
                                                                        icon="check-circle-fill" variant="success"
                                                                        class="mr-2"></b-icon></template>
                                                                <template v-else><b-icon icon="dash-circle-fill"
                                                                        variant="warning" class="mr-2"></b-icon></template>
                                                            </template>
                                                            {{ employee[f.value] }}</span></template>
                                                    <!-- end: added status icon by afrin -->
                                                </template>
                                            </td>
                                        </template>
                                        <template v-else>
                                            <!-- added by afrin -->
                                            <td class="cursor-pointer text-left" v-for="f in appended_column" v-if="column_selected.includes(f.value)">
                                                <template v-if="employee.pay_slip_name && employee.pay_slip_name != ''">
                                                    <span class="text-right d-block">{{ employee[f.value] }}</span>
                                                </template>
                                                <template v-else>
                                                    <!-- start: added status icon by afrin -->
                                                    <template><span class="cursor-pointer"
                                                            @click="editEmployee(employee[primary_key])">
                                                            <template v-if="f.value == 'status_label'">
                                                                <template v-if="employee.status == 1"><b-icon
                                                                        icon="check-circle-fill" variant="success"
                                                                        class="mr-2"></b-icon></template>
                                                                <template v-else><b-icon icon="dash-circle-fill"
                                                                        variant="warning" class="mr-2"></b-icon></template>
                                                            </template>
                                                            {{ employee[f.value] }}</span></template>
                                                    <!-- end: added status icon by afrin -->
                                                </template>
                                            </td>
                                            <!-- added by afrin -->
                                            <td class="cursor-pointer text-left" v-for="f in column_selected" v-if="!appended_values.includes(f)">
                                                <!-- <template v-if="f != 'name' && f != 'email' && f != 'phone' && f != 'department' && f != 'jobposition' && f != 'branch'"> -->
                                                <template><span class="cursor-pointer"
                                                        @click="editEmployee(employee[primary_key])">{{ employee[f]
                                                        }}</span></template>
                                            </td>
                                        </template>
                                        <td v-if="is_action == 1 && employee.actions.length > 0" class="action_td">
                                            <div class="col-sm-2 py-1 pl-0 pr-3 float-right">
                                                <a id="actionDropdown"
                                                    class="dropdown-toggle clearfix action-dropdown-toggle"
                                                    style="font-size: 16px;" href="#" role="button"
                                                    data-toggle="dropdown" aria-haspopup="true"
                                                    aria-expanded="false"><b-icon
                                                        icon="three-dots-vertical"></b-icon></a>
                                                <div class="dropdown-menu action-dropdown-menu"
                                                    aria-labelledby="actionDropdown">
                                                    <!-- alpha fix- commented this  -->
                                                    <!-- <b-button-group >
                                                            <div v-for="(row, index) in employee.actions" :key="index">
                                                            <b-button variant="outline-secondary"  @click="actionEmployee(employee[primary_key],row.value)">
                                                            <b-icon v-if="row.label == 'Review'" icon="pencil-square"></b-icon>
                                                            <b-icon v-else-if="row.label == 'Preview Taxcard'" icon="eye"></b-icon>
                                                            <b-icon v-else icon="gear"></b-icon>
                                                            {{row.label}}
                                                            </b-button>

                                                            </div>

                                                        </b-button-group> -->

                                                    <!-- alpha fix- added this  -->
                                                    <!-- alpha fix- added this  -->

                                                    <b-button-group>
                                                        <div v-for="(row, index) in employee.actions" :key="index">
                                                            <b-button variant="outline-secondary"
                                                                @click="actionEmployee(employee[primary_key], row.value)">
                                                                <b-icon v-if="row.label == 'Edit'" icon="pencil"
                                                                    class="mr-2" aria-hidden="true"></b-icon>
                                                                <i v-else-if="row.icon" :class="row.icon + ' mr-1'"></i>
                                                                <b-icon v-else-if="row.label == 'Review'"
                                                                    icon="pencil-square"></b-icon>
                                                                <b-icon v-else-if="row.label == 'Preview Taxcard'"
                                                                    icon="eye"></b-icon>
                                                                <b-icon v-else icon="gear"></b-icon>
                                                                {{ row.label }}
                                                            </b-button>

                                                        </div>

                                                    </b-button-group>
                                                </div>
                                            </div>
                                        </td>
                                        <td v-else-if="is_action == 1 && employee.actions.length == 0"
                                            class="action_td">
                                            <div class="col-sm-2 py-1 pl-0 pr-3 float-right">

                                            </div>
                                        </td>
                                    </template>
                                </template>

                                <template v-else>
                                    <template v-if="checkbox == 1">
                                        <td class="checkbox-col">
                                            <input v-if="employee.pay_slip_name && employee.pay_slip_name != ''"
                                                type="checkbox" class="justify-content-center" v-model="selected"
                                                :value="employee[primary_key]" number>
                                            <input v-if="employee.locked == 1" type="checkbox"
                                                :disabled="employee.locked == 1"
                                                class="justify-content-center trz_disable_box" v-model="selected"
                                                :value="employee[primary_key]" number>
                                            <input v-else type="checkbox" class="justify-content-center"
                                                v-model="selected" :value="employee[primary_key]" number>
                                            <label></label>
                                        </td>
                                    </template>
                                    <td class="cursor-pointer trz_relative" v-for="f in default_column">
                                        <template v-if="f == 'phone'"><span class="cursor-pointer"
                                                @click="editEmployee(employee[primary_key])">{{
                                                    formatPhoneNumber(employee.phone) }}</span></template>
                                        <template v-else-if="f == 'name'">
                                            <template v-if="edit_icon == 'yes'">
                                                <b-icon
                                                    v-if="employee.draft_flg == 1 || employee.draft_mph == 1 || employee.draft_mpfh == 1 || employee.draft_contract == 1"
                                                    icon="arrow-right-circle" variant="info" animation="fade"
                                                    class="mr-1 trz_employee_draft_edit" v-b-tooltip.hover
                                                    title="Has Draft Data"></b-icon>
                                                <b-icon v-else icon="blank"
                                                    class="mr-1 trz_employee_draft_edit"></b-icon>
                                            </template>
                                            <!-- <template v-if="checkbox==1 "><input v-if="employee.pay_slip_name && employee.pay_slip_name !=''" type="checkbox" class="justify-content-center" v-model="selected" :value="employee[primary_key]" number><input v-if="employee.locked ==1" type="checkbox" :disabled="employee.locked ==1" class="justify-content-center trz_disable_box" v-model="selected" :value="employee[primary_key]" number><input v-else type="checkbox" class="justify-content-center" v-model="selected" :value="employee[primary_key]" number></template> -->
                                            <label class="mb-0 custom-label d-flex align-items-center">
                                                <template v-if="employee.pic != ''">
                                                    <!-- <img v-if="employee.pic == 'no-image.jpg'" v-bind:src="$api_url+'/avatar/'+ employee.pic" class="img-fluid img-thumbnail employee-avatar mx-2" /> -->
                                                    <img v-if="employee.pic == 'demo.jpg'"
                                                        v-bind:src="$api_url + '/avatar/no-image.jpg'"
                                                        class="img-fluid img-thumbnail employee-avatar mx-2" />
                                                    <!-- Mustafijur: 04-05-2026 -->
                                                    <img v-else
                                                        v-bind:src="$api_url + '/avatar/' + employee.company_id + '/' + employee.pic"
                                                        class="img-fluid img-thumbnail employee-avatar mx-2" />

                                                </template>
                                                <template v-else>
                                                    <img v-bind:src="$api_url + '/avatar/demo.jpg'"
                                                        class="img-fluid img-thumbnail employee-avatar mx-2" />
                                                </template>
                                                <template v-if="employee.pay_slip_name && employee.pay_slip_name != ''">
                                                    <span v-if="$acl['createpayslipbyid'] == 2"
                                                        style="color: rgb(29, 104, 167);" class="cursor-pointer"
                                                        @click="editEmployee(employee[primary_key])">{{ employee.name }}
                                                        <template v-if="employee.is_manual == 1"><span>( Manual payslip
                                                                )</span></template></span>
                                                    <span v-else style="color: rgb(29, 104, 167);" class="">{{
                                                        employee.name }} <template
                                                            v-if="employee.is_manual == 1"><span>( Manual payslip
                                                                )</span></template></span>
                                                </template>
                                                <template v-else>
                                                    <span class="cursor-pointer"
                                                        @click="editEmployee(employee[primary_key])">{{ employee.name
                                                        }}</span>
                                                </template>
                                            </label>
                                        </template>
                                        <template v-else>{{ employee[f] }}</template>
                                    </td>
                                    <template v-if="is_payruns == 'yes'">
                                        <!-- added by afrin -->
                                        <td class="cursor-pointer text-left" v-for="f in column_selected" v-if="!appended_values.includes(f)">
                                            <template v-if="f != 'name'"><span class="cursor-pointer"
                                                    @click="editEmployee(employee[primary_key])">{{ employee[f]
                                                    }}</span></template>
                                        </td>
                                        <!-- added by afrin -->
                                        <td class="cursor-pointer text-left" v-for="f in appended_column" v-if="column_selected.includes(f.value)">
                                            <template v-if="employee.pay_slip_name && employee.pay_slip_name != ''">
                                                <span v-if="f.value == 'reviewed'" class="text-center d-block"><template
                                                        v-if="employee[f.value] == 1"><b-icon icon="check-circle-fill"
                                                            class="ml-2" variant="success"></b-icon></template><template
                                                        v-else></template></span>
                                                <span v-else class="text-right d-block">{{ employee[f.value] }}</span>
                                            </template>
                                            <template v-else>
                                                <!-- start: added status icon by afrin -->
                                                <template><span class="cursor-pointer"
                                                        @click="editEmployee(employee[primary_key])">
                                                        <template v-if="f.value == 'status_label'">
                                                            <template v-if="employee.status == 1"><b-icon
                                                                    icon="check-circle-fill" variant="success"
                                                                    class="mr-2"></b-icon></template>
                                                            <template v-else><b-icon icon="dash-circle-fill"
                                                                    variant="warning"
                                                                    class="mr-2"></b-icon></template>
                                                        </template>
                                                        {{ employee[f.value] }}</span></template>
                                                <!-- end: added status icon by afrin -->
                                            </template>
                                        </td>
                                    </template>
                                    <template v-else>
                                        <!-- added by afrin -->
                                        <td class="cursor-pointer text-left" :class="getValueClass(employee, f.value)"
                                            v-for="f in appended_column" v-if="column_selected.includes(f.value)">
                                            <template v-if="employee.pay_slip_name && employee.pay_slip_name != ''">
                                                <span class="text-right d-block">{{ employee[f.value] }}</span>
                                            </template>
                                            <template v-else>
                                                <!-- start: added status icon by afrin -->
                                                <template><span class="cursor-pointer"
                                                        @click="editEmployee(employee[primary_key])">
                                                        <template v-if="f.value == 'status_label'">
                                                            <template v-if="employee.status == 1"><b-icon
                                                                    icon="check-circle-fill" variant="success"
                                                                    class="mr-2"></b-icon></template>
                                                            <template v-else><b-icon icon="dash-circle-fill"
                                                                    variant="warning"
                                                                    class="mr-2"></b-icon></template>
                                                        </template>
                                                        {{ employee[f.value] }}</span></template>
                                                <!-- end: added status icon by afrin -->
                                            </template>
                                        </td>
                                        <!-- added by afrin -->
                                        <td class="cursor-pointer text-left" v-for="f in column_selected" v-if="!appended_values.includes(f)">
                                            <!-- <template v-if="f != 'name' && f != 'email' && f != 'phone' && f != 'department' && f != 'jobposition' && f != 'branch'"> -->
                                            <template><span class="cursor-pointer"
                                                    @click="editEmployee(employee[primary_key])">{{ employee[f]
                                                    }}</span></template>
                                        </td>
                                    </template>
                                    <td v-if="is_action == 1 && employee.actions.length > 0" class="action_td">
                                        <div class="col-sm-2 py-1 pl-0 pr-3 float-right">
                                            <a id="actionDropdown"
                                                class="dropdown-toggle clearfix action-dropdown-toggle"
                                                style="font-size: 16px;" href="#" role="button" data-toggle="dropdown"
                                                aria-haspopup="true" aria-expanded="false"><b-icon
                                                    icon="three-dots-vertical"></b-icon></a>
                                            <div class="dropdown-menu action-dropdown-menu"
                                                aria-labelledby="actionDropdown">
                                                <!-- alpha fix- commented this  -->
                                                <!-- <b-button-group >
                                                        <div v-for="(row, index) in employee.actions" :key="index">
                                                        <b-button variant="outline-secondary"  @click="actionEmployee(employee[primary_key],row.value)">
                                                        <b-icon v-if="row.label == 'Review'" icon="pencil-square"></b-icon>
                                                        <b-icon v-else-if="row.label == 'Preview Taxcard'" icon="eye"></b-icon>
                                                        <b-icon v-else-if="row.label == 'Locked'" icon="lock-fill"></b-icon>

                                                        <b-icon v-else icon="gear" ></b-icon>
                                                        {{row.label}}
                                                        </b-button>

                                                        </div>

                                                    </b-button-group> -->

                                                <!-- alpha fix- added this  -->
                                                <!-- alpha fix- added this  -->

                                                <b-button-group>
                                                    <div v-for="(row, index) in employee.actions" :key="index">
                                                        <b-button variant="outline-secondary"
                                                            @click="actionEmployee(employee[primary_key], row.value)">
                                                            <b-icon v-if="row.label == 'Edit'" icon="pencil"
                                                                class="mr-2" aria-hidden="true"></b-icon>
                                                            <i v-else-if="row.icon" :class="row.icon + ' mr-1'"></i>
                                                            <b-icon v-else-if="row.label == 'Review'"
                                                                icon="pencil-square"></b-icon>
                                                            <b-icon v-else-if="row.label == 'Preview Taxcard'"
                                                                icon="eye"></b-icon>
                                                            <b-icon v-else icon="gear"></b-icon>
                                                            {{ row.label }}
                                                        </b-button>

                                                    </div>

                                                </b-button-group>
                                            </div>
                                        </div>
                                    </td>
                                    <td v-else-if="is_action == 1 && employee.actions.length == 0" class="action_td">
                                        <div class="col-sm-2 py-1 pl-0 pr-3 float-right">

                                        </div>
                                    </td>
                                </template>

                            </tr>
                        </tbody>
                    </table>
                </div>
                <!--</div>-->
                <!--</div>-->
                <!-- list view ends here -->
                <!-- grid view starts here -->
                <div class="grid-view my-3 clearfix employee-grid-view" v-else>
                    <div class="container-fluid px-0">
                        <div class="grid">
                            <div class="grid-item hover-bg cursor-pointer overflow-hidden"
                                v-for="employee in paginatedData" :key="employee[primary_key]">
                                <div class="grid-employee-img">
                                    <template v-if="employee.pic != ''">
                                        <img v-if="employee.pic == 'no-image.jpg'"
                                            v-bind:src="$api_url + '/avatar/' + employee.pic"
                                            class="img-fluid img-thumbnail" />
                                        <!-- Mustafijur Removed: employee-avatar mx-2 on 12-04-2026 -->
                                        <img v-else
                                            v-bind:src="$api_url + '/avatar/' + employee.company_id + '/' + employee.pic"
                                            class="img-fluid img-thumbnail" />
                                        <!-- Mustafijur Removed: employee-avatar mx-2 on 12-04-2026 -->
                                    </template>
                                    <template v-else>
                                        <img v-bind:src="$api_url + '/avatar/demo.jpg'"
                                            class="img-fluid img-thumbnail" />
                                        <!-- Mustafijur Removed: employee-avatar mx-2 on 12-04-2026 -->
                                    </template>
                                </div>
                                <div class="grid-employee-data text-center">
                                    <span>{{ employee.name }}</span>
                                    <span>{{ employee.jobposition }}<span
                                            v-if="employee.department !== '' && employee.jobposition !== ''">, </span>
                                        {{ employee.department }}</span>
                                </div>
                                <div v-if="is_company_directory == 'yes'"
                                    class="grid-hover-wrapper position-absolute p-2 w-100 h-100 d-flex justify-content-center align-items-center text-center">
                                    <div class="grid-hover-wrapper-inner">
                                        <span class="grid-emp-title d-block">{{ employee.name }}</span>
                                        <span class="d-block">{{ employee.jobposition }}<span
                                                v-if="employee.department !== '' && employee.jobposition !== ''">,
                                            </span>
                                            {{ employee.department }}</span>
                                        <hr />
                                        <span class="d-block">Contact: <b>{{ formatPhoneNumber(employee.phone)
                                        }}</b></span>
                                        <span class="d-block">Email: <b>{{ employee.email }}</b></span>
                                        <span class="d-block">Employee Code: {{ employee.employee_code }}</span>
                                    </div>
                                </div>
                                <!-- Mustafijur: Start - Deprecated block on 12-04-2026 -->
                                <!-- <div class="grid-employee-viewmore mt-4">
                                    <b-button variant="primary" class="w-100" title="Edit" v-if="viewmode==false" @click="editEmployee(employee[primary_key])">View Details</b-button>
                                </div> -->
                                <!-- Mustafijur: End - Deprecated block -->

                                <!-- Mustafijur: Start - Grid Hover Overlay on 12-04-2026 -->
                                <div v-else
                                    class="grid-hover-wrapper position-absolute p-2 w-100 h-100 d-flex justify-content-center align-items-center text-center">
                                    <div class="grid-hover-wrapper-inner">
                                        <div class="grid-employee-img d-flex align-items-center justify-content-center">
                                            <b-button variant="primary" class="btn-white" title="Edit"
                                                v-if="viewmode == false"
                                                @click="editEmployee(employee[primary_key])">View
                                                Details</b-button>
                                        </div>
                                        <div class="grid-employee-data text-center">
                                            <span>{{ employee.name }}</span>
                                            <span>{{ employee.jobposition }}<span
                                                    v-if="employee.department !== '' && employee.jobposition !== ''">,
                                                </span> {{ employee.department }}</span>
                                        </div>
                                    </div>
                                </div>
                                <!-- Mustafijur: End - Grid Hover Overlay -->
                            </div>
                        </div>
                    </div>
                </div>
                <!-- grid view ends here -->
                <div class="row py-2 no-margin" v-if="paginatedData.length > 0">
                    <div class="col-md-12 p-0 no-margin" v-if="paginatedData.length > 0">
                        <ul class="pagination b-pagination float-left mb-0 mt-1">
                            <li class="page-item disabled m-2">View</li>
                            <li class="page-item disabled"><b-form-select v-model="temp_length"
                                    :options="length_options" @change="setFirstPage()"></b-form-select></li>
                            <li class="page-item disabled m-2">per page. Total {{ people }} records found.</li>
                        </ul>
                        <b-pagination-nav class="float-right mt-1" v-model="pagination.currentPage"
                            :number-of-pages="pagination.pages" prev-text="Previous" next-text="Next" base-url="#"
                            first-number last-number></b-pagination-nav>
                    </div>

                </div>
                <div v-if="paginatedData.length == 0" class="px-3 py-3 no-result-cell text-center">
                    <span class="d-block text-center">{{ blankmsg }}</span>
                    <img v-if="show_loader" v-bind:src="$api_url + '/images/download-loader.svg'" class="loader-logo"
                        width="100px" />
                </div>
            </div>

            <b-sidebar id="sidebar_right" title="Filter" right shadow>
                <filter-list :key="sidebar_key" :company_options="company_options" :search_by_filter="search_by_filter"
                    :default_column="default_column" :column_selected="column_selected"
                    v-on:childToParent="filterList"></filter-list>
            </b-sidebar>
            {{ clickSelect }}
        </div>

    </b-overlay>
</template>


<script>
export default {
    props: ['employees', 'default_column', 'appended_column', 'company_options', 'primary_key', 'email_class', 'checkbox', 'is_action', 'is_pf', 'payslipids', 'switch_view', 'is_payruns', 'all_employee', 'is_company_directory', 'edit_icon','hide_fields', 'preselected'], // hide_fields is added by Afrin, preselected added by asfaq

    data() {

        let sortOrders = {};

        //columns.forEach((column) => {sortOrders[column.name] = -1;});

        return {

            columns: [],
            sortKey: 'name',
            sortOrders: sortOrders,
            pagination: { currentPage: 1, total: '', nextPage: '', prevPage: '', from: '', to: '', nextbuttonstatus: 'true', prebuttonstatus: 'disabled' },
            tmp_column_selected: [],
            column_selected: [], // Must be an array reference!
            default_options: [],
            appended_options: [],
            column_options: [],
            search_by_filter: [],
            selected: [],
            backdoor: 0,
            sidebar_key: 0,
            selected_ids: [],
            showoverlay: true,
            viewmode: true,
            notice: "",
            blankmsg: 'Fetching data..',
            people: 0,
            company_name: '',
            filter_by_id: ['jobposition_id', 'department_id', 'branch_id', 'blood_group_id'],
            search: '',
            length: 20,
            temp_length: 20,
            length_options: [],
            pagination: { currentPage: 1, total: '', nextPage: '', prevPage: '', from: '', to: '', pages: 1 },
            status_flag: false,
            show_loader: false,
            tableStickyHeight: '',

        }
    },
    methods: {

        // Mustafijur: 05-05-2026: Starts
        getValueClass: function (data, key) {
            var strclass = '';
            // if(key == 'loan_status' || key == 'status')
            if (key == 'loan_status') {
                strclass = 'status-label status-label-' + data[key].toLowerCase().replace('/', '-');
            }

            return strclass;
        },
        // Mustafijur: 05-05-2026: Ends
        sortBy(key) {
            this.resetPagination();
            this.sortKey = key;
            this.sortOrders[key] = this.sortOrders[key] * -1;

            this.backdoor++;
        },
        filterList(value) {
            console.log(value);
            this.resetPagination();
            if (value['reset'] == 1) {
                this.search_by_filter = value['search_by_filter'];
                this.sortBy('name');
                $("#filter_button").click();

                //this.resetFlter();
            }
        },

        stringView(str) {
            var i, frags = str.split('_');
            for (i = 0; i < frags.length; i++) {
                frags[i] = frags[i].charAt(0).toUpperCase() + frags[i].slice(1);
            }
            return frags.join(' ');
        },
        getIndex(array, key, value) {
            return array.findIndex(i => i[key] == value)
        },

        setcolumn: function () {
            this.$cookies.set(this.cookie_name, this.column_selected); // added by afrin

            this.$refs.dropdown.hide(true);
        },
        toMoney: function (amount) {
            if (amount != "0") {
                if (!isNaN(amount)) {
                    var number = Number(amount);
                    return number;
                }
                var NumWithoutCommas = amount.replace(/,/g, '');
                var number = Number(NumWithoutCommas).toFixed(2);
                return number;
            } else
                return amount;
        },

        generateList: function () {

            this.showoverlay = false;
            if (this.employees.length > 0) {
                let cr = {};

                if (this.company_options.length > 0) {
                    this.company_options.forEach(element => {

                        if (element.type == "date") {
                            cr[element.label + '_from'] = '';
                            cr[element.label + '_to'] = '';
                        }
                        else if (element.label == 'jobposition') {
                            cr['jobposition_id'] = [];
                        }
                        else if (element.label == 'department') {
                            cr['department_id'] = [];
                        }
                        else if (element.label == 'branch') {
                            cr['branch_id'] = [];
                        }
                        else if (element.label == 'blood_group') {
                            cr['blood_group_id'] = [];
                        }
                        else if (element.options && element.options.length > 0) {
                            cr[element.label] = [];
                        }
                        else {
                            cr[element.label] = '';
                        }

                    });
                }

                this.search_by_filter = cr;
                let co = [];
                let cl = [];
                let dop = [];
                if (this.company_options.length > 0) {
                    this.company_options.forEach(element => {

                        if (1) {
                            cl = cl.concat([{ label: this.stringView(element.label), name: element.label, type: element.type }]);

                            if (!this.default_column.includes(element.label)) {
                                co = co.concat([{ text: this.stringView(element.label), value: element.label }]);
                            }
                            if (this.default_column.includes(element.label)) {
                                dop = dop.concat([{ text: this.stringView(element.label), value: element.label }]);
                            }
                        }



                    });
                }
                let aop = [];
                let aopcl = [];
                for (let i = 0; i < this.appended_column.length; i++) {
                    aop = aop.concat([{ text: this.stringView(this.appended_column[i].text), value: this.appended_column[i].value }]);
                    aopcl = aopcl.concat([{ label: this.stringView(this.appended_column[i].text), name: this.appended_column[i].value, type: this.appended_column[i].type }]);
                }

                this.appended_options = this.appended_options.concat(aop);
                this.default_options = this.default_options.concat(dop);
                this.column_options = this.column_options.concat(co);
                this.columns = this.columns.concat(cl);
                this.columns = this.columns.concat(aopcl);
                this.columns.forEach((column) => { this.sortOrders[column.name] = -1; });
                if (this.employees.length == 0) {
                    if (this.is_payruns == 'yes') {
                        this.blankmsg = "Loading relevant payslips...";
                        this.show_loader = true;
                    } else {
                        this.blankmsg = "Looks like there is no relevant data here.";
                        this.show_loader = false;
                    }
                }
                else {
                    this.tableStickyHeight = 'table-sticky-height';
                    this.length_options = [{ value: 20, text: "20" },
                    { value: 50, text: "50" },
                    { value: 100, text: "100" },
                    { value: 1500, text: "1500" }
                    ];
                    this.people = this.employees.length;
                    this.sortBy('name');
                }

            }
            else {
                let dop = [];
                let cl = [];
                this.default_column.forEach(element => {
                    cl = cl.concat([{ label: this.stringView(element), name: element }]);
                    dop = dop.concat([{ text: this.stringView(element), value: element }]);
                });
                this.columns = this.columns.concat(cl);
                this.default_options = this.default_options.concat(dop);
                if (this.is_payruns == 'yes') {
                    this.blankmsg = "Loading relevant payslips...";
                    this.show_loader = true;
                } else {
                    this.blankmsg = "Looks like there is no relevant data here.";
                    this.show_loader = false;
                }
            }


        },
        editEmployee: function (em_id) {
            let value = [];
            value[this.primary_key] = em_id;
            value['action_id'] = 0;
            value['selected'] = [];
            value['column_selected'] = [];
            this.$emit('childToParent', value);
        },
        actionEmployee: function (em_id, action_id) {
            let value = [];
            value[this.primary_key] = em_id;
            value['action_id'] = action_id;
            value['selected'] = [];
            value['column_selected'] = [];
            this.$emit('childToParent', value);
        },
        getPrimaryKey: function () {
            return this.primary_key;
        },
        getDateObj(start_month) {
            let str_month_arr = [];
            var m_names = ['january', 'february', 'march',
                'april', 'may', 'june', 'july',
                'august', 'september', 'october', 'november', 'december'];

            if (start_month.includes("-")) {
                str_month_arr = start_month.split("-");
            }
            else {
                str_month_arr = start_month.split(" ");
            }

            var yr1 = parseInt(str_month_arr[1]);
            var mt = str_month_arr[0];
            var mon1 = m_names.indexOf(mt);
            var d1 = new Date(yr1, mon1).getTime();
            return d1;
        },
        parseDate(x) {
            if (x == null) return NaN;
            if (x instanceof Date) return x.setHours(0, 0, 0, 0);
            if (typeof x == 'number') return x;
            const m = String(x).match(/^(\d{4})-(\d{2})-(\d{2})$/);
            if (m) return Date.UTC(+m[1], +m[2] - 1, +m[3]);
            const d = new Date(x);
            return isNaN(d) ? NaN : d.setHours(0, 0, 0, 0);
        }

    },
    created: function () {
        if (this.all_employee == 'yes') {
            this.status_flag = true;
        }
        // asfaq 29 sep 2026
        if(Array.isArray(this.preselected) && this.preselected.length > 0){
            this.selected = this.preselected.map(id => Number(id));
        }
        // asfaq 29 sep 2026

        // hide_fields is added by Afrin start
        if (this.hide_fields === 'yes') {
            let appended_values = this.appended_column ? this.appended_column.map(col => col.value) : [];
            let all_cols = [...appended_values];
            if (this.company_options && this.company_options.length > 0) {
                this.company_options.forEach(element => {
                    if (!this.default_column.includes(element.label) && element.label !== 'company') {
                        if (!all_cols.includes(element.label)) {
                            all_cols.push(element.label);
                        }
                    }
                });
            }
            this.column_selected = all_cols;
        }
        // hide_fields is added by Afrin end
        else if (this.$cookies.isKey(this.cookie_name)) { // added by afrin

            if (this.$cookies.get(this.cookie_name) != null && this.$cookies.get(this.cookie_name) != '') {
                if (Array.isArray(this.$cookies.get(this.cookie_name))) {
                    this.column_selected = this.$cookies.get(this.cookie_name);
                }
                else {
                    this.column_selected = this.$cookies.get(this.cookie_name).split(',');
                }
            }

        }
        else {
            this.column_selected = [...this.appended_values]; // added by afrin
        }
        this.generateList();



        $(window).on('load', function (e) {
            setTimeout(function () {
                $('.div1').width($('table.employee-list-table').width());
                $('.div2').width($('table.employee-list-table').width());
                if ($('table.employee-list-table').width() > $('.wrapper1').width()) {
                    //alert($('table.employee-list-table').width());
                    $('.wrapper1').show();
                } else {
                    //alert('Its not bigger');
                    $('.wrapper1').hide();
                }
            }, 2000);
            $('.wrapper1').on('scroll', function (e) {
                $('.wrapper2').scrollLeft($('.wrapper1').scrollLeft());
            });
            $('.wrapper2').on('scroll', function (e) {
                $('.wrapper1').scrollLeft($('.wrapper2').scrollLeft());
            });

            $(document).on("click", ".trz-custom-dropdown .custom-switch input", function () {
                setTimeout(function () {
                    $('.div1').width($('table.employee-list-table').width());
                    $('.div2').width($('table.employee-list-table').width());
                    if ($('table.employee-list-table').width() > $('.wrapper1').width()) {
                        $('.wrapper1').show();
                    } else {
                        $('.wrapper1').hide();
                    }
                }, 500);
            });
        });

    },
    computed:
    {
        //  added by afrin
        appended_values() {
            return this.appended_column ? this.appended_column.map(col => col.value) : [];
        },
        cookie_name() {
            return "column_selected_" + (this.primary_key || "default") + (this.appended_values.length > 0 ? "_" + this.appended_values.join('_') : "");
        },
        filteredData() {
            this.backdoor;

            let filtered_list = this.employees;
            let search_by_custom_fields = this.search_by_filter;
            let search_terms = [];

            if (search_by_custom_fields) {
                Object.keys(search_by_custom_fields).forEach(key => {
                    let val = search_by_custom_fields[key];

                    if (key.endsWith('_from') || key.endsWith('_to')) {
                        if (val != '') {
                            search_terms.push({
                                key: key,
                                value: val,
                                type: 'date'
                            });
                        }
                    }
                    else if (this.column_selected.includes(key) || this.default_column.includes(key) || this.filter_by_id.includes(key)) {
                        if (Array.isArray(val)) {
                            if (val.length > 0) {
                                search_terms.push({
                                    key: key,
                                    value: val,
                                    type: 'multi'
                                });
                            }
                        }
                        else if (val != '') {
                            search_terms.push({
                                key: key,
                                value: val,
                                type: 'single'
                            });
                        }
                    }

                    if (this.all_employee == 'yes') {
                        if (search_by_custom_fields['status'] == '' && key == 'status') {
                            search_terms.push({
                                key: 'status',
                                value: 'Active',
                                type: 'single'
                            });
                        }
                    }
                });
            }

            if (search_terms.length > 0) {
                for (let i = 0; i < search_terms.length; i++) {
                    let search_key = search_terms[i].key;
                    let search_value = search_terms[i].value;
                    let search_type = search_terms[i].type;

                    if (search_key == 'status') {
                        filtered_list = filtered_list.filter((row) => {
                            return String(row[search_key] ?? '').toLowerCase().indexOf(String(search_value).toLowerCase()) == 0;
                        });
                    }
                    else {
                        filtered_list = filtered_list.filter((row) => {
                            const baseKey = search_key.replace(/_(from|to)$/, '');
                            const raw = row[baseKey];

                            if (search_key.endsWith('_from') || search_key.endsWith('_to')) {
                                const v = this.parseDate(raw);
                                const s = this.parseDate(search_value);

                                if (isNaN(v) || isNaN(s)) {
                                    return false;
                                }

                                if (search_key.endsWith('_from')) {
                                    return v >= s;
                                }

                                return v <= s;
                            }

                            if (search_type == 'multi') {
                                return search_value.map(String).includes(String(raw));
                            }

                            return String(raw ?? '').toLowerCase().includes(String(search_value).toLowerCase());
                        });
                    }
                }

                this.pagination.currentPage = 1;

                if (filtered_list.length == 0) {
                    this.blankmsg = "Nothing found.";

                    if (this.all_employee == 'yes') {
                        if (this.search_by_filter['status'] == '' || this.search_by_filter['status'] == 'Active') {
                            this.blankmsg = "No active employee found.";
                        }
                    }
                }

                if (this.all_employee == 'yes') {
                    if (filtered_list.length > 0) {
                        if (filtered_list[0]['status'] && filtered_list[0]['status'] != '') {
                            this.status_flag = false;
                        }
                        else {
                            this.status_flag = true;
                        }
                    }
                }
            }

            if (this.search) {
                filtered_list = filtered_list.filter((row) => {
                    return Object.keys(row).some((key) => {
                        return String(row[key] ?? '').toLowerCase().indexOf(this.search.toLowerCase()) > -1;
                    });
                });

                if (filtered_list.length == 0) {
                    this.blankmsg = "Nothing found.";
                }
            }

            let sortKey = this.sortKey;
            let order = this.sortOrders[sortKey] || 1;

            if (sortKey) {
                filtered_list = filtered_list.slice().sort((a, b) => {
                    let index = this.getIndex(this.columns, 'name', sortKey);
                    a = String(a[sortKey]).toLowerCase();
                    b = String(b[sortKey]).toLowerCase();
                    if (a === b) {
                        return 0;
                    }
                    return a > b ? order : -order;
                });
            }

            this.people = filtered_list.length;

            return filtered_list;
        },
        paginatedData() {
            this.backdoor;

            return this.paginate(this.filteredData, this.length, this.pagination.currentPage);
        },
        selectAll: {
            get: function () {
                return this.paginatedData ? this.selected.length == this.paginatedData.length : false;
            },
            set: function (value) {
                var selected = [];
                var pm_key = this.getPrimaryKey();
                console.log(pm_key);
                if (value) {
                    this.paginatedData.forEach(function (user) {
                        if (user.pay_slip_name && user.pay_slip_name != '')
                            selected.push(user.id);
                        else {
                            if (user.locked != 1) {
                                selected.push(user[pm_key]);
                            }

                        }

                    });
                }
                this.selected = selected;
            }
        },
        clickSelect() {

            if (this.selected.length != this.selected_ids.length) {
                this.selected_ids = this.selected;
                let value = [];
                value[this.primary_key] = 0;
                value['action_id'] = 0;
                value['selected'] = this.selected;
                value['column_selected'] = [];
                this.$emit('childToParent', value);
            }
            if (this.is_payruns && this.is_payruns == 'yes') {
                //this.$cookies.set("report_column_selected", this.column_selected);
                let value = [];
                value[this.primary_key] = 0;
                value['action_id'] = 0;
                value['selected'] = this.selected;
                value['column_selected'] = this.column_selected;
                this.$emit('childToParent', value);
            }
            // hide_fields is added by Afrin start
            if (this.hide_fields !== 'yes') {
                this.$cookies.set(this.cookie_name, this.column_selected);
            }
            // hide_fields is added by Afrin end
        },
    }
}
</script>
<style>
.employee-list-table tr td:last-child {
    padding-right: 20px;
}

.action_thead {
    text-align: right;
}

.trz_disable_box+label::before {
    background: #adb5bdab !important;
}

.trz_people_btn.trz_email {
    right: 0;
    top: -185px;
}

.trz_employee_draft_edit {
    position: absolute;
    left: 12px;
    top: 18px;
}

.trz_relative {
    position: relative;
}
</style>